import { SiVisualstudiocode as VsCodeIcon } from 'react-icons/si';

import { PLACEHOLDER } from './placeholders';
import buildHeaderLines from './headers';
import {
  AUTH_TOKEN,
  AUTH_USER_PASSWORD,
  BLOCK_FILE,
  BLOCK_INSTRUCTIONS,
  BLOCK_NOTE,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const buildServerConfig = (authMethod) => `{
  "servers": {
    "faraday": {
      "type": "http",
      "url": "${PLACEHOLDER.serverUrl}",
      "headers": {
${buildHeaderLines(authMethod, '        ', ': ')}
      }
    }
  }
}`;

const promptedTokenConfig = `{
  "inputs": [
    {
      "type": "promptString",
      "id": "faraday-token",
      "description": "Faraday API token",
      "password": true
    }
  ],
  "servers": {
    "faraday": {
      "type": "http",
      "url": "${PLACEHOLDER.serverUrl}",
      "headers": {
        "X-Faraday-URL": "${PLACEHOLDER.instanceUrl}",
        "X-Faraday-Token": "\${input:faraday-token}"
      }
    }
  }
}`;

const vsCode = {
  id: 'vsCode',
  label: 'VS Code',
  subLabel: 'GitHub Copilot',
  icon: VsCodeIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN, AUTH_USER_PASSWORD],
  summaryId: 'mcp.client.vsCode.summary',
  buildSections: ({ authMethod }) => [
    {
      id: 'workspace',
      titleId: 'mcp.client.vsCode.workspace.title',
      blocks: [
        {
          id: 'workspace-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.vsCode.workspace.caption',
          snippet: buildServerConfig(authMethod)
        },
        {
          id: 'workspace-note',
          type: BLOCK_NOTE,
          textId: 'mcp.client.vsCode.workspace.note'
        }
      ]
    },
    {
      id: 'prompted-token',
      titleId: 'mcp.client.vsCode.promptedToken.title',
      blocks: [
        {
          id: 'prompted-token-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.vsCode.promptedToken.caption',
          snippet: promptedTokenConfig,
          hiddenForAuthMethod: AUTH_USER_PASSWORD
        }
      ]
    },
    {
      id: 'start',
      titleId: 'mcp.client.vsCode.start.title',
      blocks: [
        {
          id: 'start-steps',
          type: BLOCK_INSTRUCTIONS,
          items: [
            { id: 'start', textId: 'mcp.client.vsCode.start.open' },
            { id: 'agent', textId: 'mcp.client.vsCode.start.agent' },
            { id: 'tools', textId: 'mcp.client.vsCode.start.tools' }
          ]
        }
      ]
    }
  ]
};

export default vsCode;
